/**
 * Domain status helpers: obligation and document status labels/classes.
 * Shared across admin, public home, and shared components.
 */

export const OBLIGATION_STATUS_LABELS = {
  DRAFT: 'Нацрт',
  CREATED: 'Предложена',
  UNDER_REVIEW: 'Узета у разматрање',
  REJECTED: 'Није прихваћена',
  ACCEPTED: 'Прихваћена',
  PARTIALLY_ACCEPTED: 'Делимично прихваћена',
  REJECTED_AFTER_REVIEW: 'Није прихваћена након прегледа',
  IN_IMPLEMENTATION: 'У спровођењу',
  INAPPROPRIATE: 'Непримерена',
};
export const OBLIGATION_STATUS_CLASSES = {
  DRAFT: 'status-created',
  CREATED: 'status-draft',
  UNDER_REVIEW: 'status-in-review',
  REJECTED: 'status-rejected',
  ACCEPTED: 'status-accepted',
  PARTIALLY_ACCEPTED: 'status-partially-accepted',
  REJECTED_AFTER_REVIEW: 'status-rejected-after-review',
  IN_IMPLEMENTATION: 'status-in-implementation',
  INAPPROPRIATE: 'status-inappropriate',
};

export const getObligationStatusLabel = (status) =>
  OBLIGATION_STATUS_LABELS[status] || status || 'Непознат статус';
export const getObligationStatusClass = (status) =>
  OBLIGATION_STATUS_CLASSES[status] || 'status-unknown';

export const OBLIGATION_STATUS_OPTIONS = [
  { value: 'DRAFT', label: OBLIGATION_STATUS_LABELS.DRAFT, color: '#475569', bgColor: '#f1f5f9', borderColor: '#94a3b8', inactiveBgColor: '#f8fafc' },
  { value: 'CREATED', label: OBLIGATION_STATUS_LABELS.CREATED, color: '#d97706', bgColor: '#fef3c7', borderColor: '#f59e0b', inactiveBgColor: '#fffbeb' },
  { value: 'UNDER_REVIEW', label: OBLIGATION_STATUS_LABELS.UNDER_REVIEW, color: '#d97706', bgColor: '#fef3c7', borderColor: '#f59e0b', inactiveBgColor: '#fffbeb' },
  { value: 'ACCEPTED', label: OBLIGATION_STATUS_LABELS.ACCEPTED, color: '#047857', bgColor: '#d1fae5', borderColor: '#10b981', inactiveBgColor: '#ecfdf5' },
  { value: 'PARTIALLY_ACCEPTED', label: OBLIGATION_STATUS_LABELS.PARTIALLY_ACCEPTED, color: '#92400e', bgColor: '#fef3c7', borderColor: '#f59e0b', inactiveBgColor: '#fffbeb' },
  { value: 'REJECTED', label: OBLIGATION_STATUS_LABELS.REJECTED, color: '#991b1b', bgColor: '#fee2e2', borderColor: '#fca5a5', inactiveBgColor: '#fef2f2' },
  { value: 'INAPPROPRIATE', label: OBLIGATION_STATUS_LABELS.INAPPROPRIATE, color: '#991b1b', bgColor: '#fee2e2', borderColor: '#fca5a5', inactiveBgColor: '#fef2f2' },
  { value: 'REJECTED_AFTER_REVIEW', label: OBLIGATION_STATUS_LABELS.REJECTED_AFTER_REVIEW, color: '#991b1b', bgColor: '#fee2e2', borderColor: '#fca5a5', inactiveBgColor: '#fef2f2' },
  { value: 'IN_IMPLEMENTATION', label: OBLIGATION_STATUS_LABELS.IN_IMPLEMENTATION, color: '#047857', bgColor: '#d1fae5', borderColor: '#10b981', inactiveBgColor: '#ecfdf5' },
];

export const PROPOSAL_STATUS_OPTIONS = [
  'CREATED',
  'UNDER_REVIEW',
  'REJECTED',
  'INAPPROPRIATE',
  'ACCEPTED',
  'PARTIALLY_ACCEPTED',
  'IN_IMPLEMENTATION',
];

/** Statusi obaveza vidljivi javno (početna). INAPPROPRIATE se nikad ne prikazuje korisnicima. */
export const PUBLIC_OBLIGATION_STATUSES = [
  'UNDER_REVIEW',
  'ACCEPTED',
  'PARTIALLY_ACCEPTED',
  'REJECTED',
  'REJECTED_AFTER_REVIEW',
  'IN_IMPLEMENTATION',
];

const DOCUMENT_STATUS_LABELS = {
  published: 'Објављено',
  draft: 'Нацрт',
  archived: 'Архивирано',
};
const DOCUMENT_STATUS_CLASSES = {
  published: 'status-accepted',
  draft: 'status-in-review',
  archived: 'status-unknown',
};

export const getDocumentStatusLabel = (status) =>
  DOCUMENT_STATUS_LABELS[status] || status || 'Непознат статус';
export const getDocumentStatusClass = (status) =>
  DOCUMENT_STATUS_CLASSES[status] || 'status-unknown';
